import { Component, Element, h, State } from '@stencil/core';

const COMPONENT_NAME = 'call-to-action-type-2';

/**
 * @slot heading - {required}, <me-heading variant="2">
 * @slot description - {required}, <me-text>
 * @slot action-primary - {required}, <form-sign-up-type-1 mobile-layout="stacked">, <me-button variant="primary">
 * @slot action-secondary - <me-button variant="secondary">
 * @slot media - {required}, <me-picture lazy="true" aspectRatio="1.5">
 */

@Component({
  tag: 'call-to-action-type-2',
  styleUrl: 'index.scss',
  shadow: false,
})
export class CallToActionType2 {
  @Element() el: HTMLElement;
  @State() hasActionSecondary: boolean = false;

  /**
   * Check if action-secondary slot has content before first render.
   * This prevents extra re-renders by setting state synchronously.
   */
  componentWillLoad() {
    // Check for slotted content - slots are available in componentWillLoad
    // We can check the element's children that have slot="action-secondary"
    this.hasActionSecondary = !!this.el.querySelector('[slot="action-secondary"]');
  }

  render() {
    return (
      <me-section class={COMPONENT_NAME} yGap="2xl" yGapLg="5xl" role="region" aria-label="Call to Action">
        <me-row yGapLg="none" yGap="none" xGapLg="none" xGap="none" alignLg="center" class={`${COMPONENT_NAME}__content`}>
          <me-column span="12" spanLg="6" class={`${COMPONENT_NAME}__intro`}>
            <slot name="heading"></slot>
            <slot name="description"></slot>
            <me-row xGap="md" xGapLg="md" yGap="md" yGapLg="md" justify="center" justifyLg="start">
              <me-column span="auto">
                <slot name="action-primary"></slot>
              </me-column>
              <me-column span="auto" class={this.hasActionSecondary ? '' : 'me-column--hidden'}>
                <slot name="action-secondary"></slot>
              </me-column>
            </me-row>
          </me-column>
          <me-column span="12" spanLg="6" class={`${COMPONENT_NAME}__media`}>
            <slot name="media"></slot>
          </me-column>
        </me-row>
      </me-section>
    );
  }
}
